import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Input, Icon, Table, Popup, Modal} from 'semantic-ui-react';
import {toFloat, toInteger} from '../../../../common/util/fieldsNormalization';
import {setErrorMessage} from '../../../../common/components/form/common';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {Actions} from '../../../../common/actions';

class ItemsTable extends Component {
  checkRequiredField(value) {
    return value ? null : 'Required';
  }

  getPart(position, e) {
    const value = e.target.value;
    if (value) {
      this.props.fetchPart(value, position);
    }
  }

  updateQuantity(index, e) {
    const quantity = parseInt(e.target.value, 10);
    const unitPrice = null;
    const weight = null;
    this.updateTotalValues({index, quantity, unitPrice, weight});
  }

  updateAmount(index, e) {
    const quantity = null;
    const unitPrice = parseFloat(e.target.value);
    const weight = null;
    this.updateTotalValues({index, quantity, unitPrice, weight});
  }

  updateWeight(index, e) {
    const quantity = null;
    const unitPrice = null;
    const weight = parseFloat(e.target.value);
    this.updateTotalValues({index, quantity, unitPrice, weight});
  }

  updateTotalValues({index, quantity, unitPrice, weight}) {
    this.props.updateTotals({index, quantity, unitPrice, weight});
  }

  onDeleteClick(fields, position) {
    fields.remove(position);
  }

  renderItems(
    fields,
    editingAllowedOfInvoice,
    {itemsByPage, pageNumber, pageSize}
  ) {
    const {itemsCount, hasToVerfyWeight} = this.props;
    if (itemsCount === 0) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={12}>
            <p className='error'>Debe agregar al menos un item</p>
          </Table.Cell>
        </Table.Row>
      );
    }

    return itemsByPage.map((item, index) => {
      const position = pageNumber * pageSize + index;
      const itemName = `detail[${position}]`;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            <h4>{position + 1}</h4>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Field
              name={`${itemName}.caseNumber`}
              type='text'
              component={Input}
              required
              validate={this.checkRequiredField}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={(event) => setErrorMessage('', event)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Caja No'
            />
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Field
              name={`${itemName}.orderNumber`}
              type='text'
              component={Input}
              required
              validate={this.checkRequiredField}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={(event) => setErrorMessage('', event)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Pedido No'
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='item-number-field'>
            <Field
              name={`${itemName}.itemNumber`}
              type='text'
              component={Input}
              disabled={!editingAllowedOfInvoice}
              placeholder='Item No'
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='part-code-field'>
            <Field
              name={`${itemName}.partNumber`}
              type='text'
              required
              validate={this.checkRequiredField}
              component={Input}
              normalize={(value) => value.toUpperCase()}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={(event) => setErrorMessage('', event)}
              onBlur={this.getPart.bind(this, position)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Parte No'
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='part-name-field'>
            <Field
              name={`${itemName}.partName`}
              type='text'
              component={Input}
              required
              validate={this.checkRequiredField}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={(event) => setErrorMessage('', event)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Nombre Parte'
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='quantity-field'>
            <Field
              name={`${itemName}.quantity`}
              type='number'
              component={Input}
              required
              validate={this.checkRequiredField}
              normalize={toInteger}
              min='1'
              step='1'
              onInvalid={(event) =>
                setErrorMessage(
                  'Por favor, llene este campo solo con números enteros mayor a cero',
                  event
                )
              }
              onInput={(event) => setErrorMessage('', event)}
              onBlur={this.updateQuantity.bind(this, position)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Cant.'
            />
          </Table.Cell>
          <Table.Cell textAlign='center' className='price-field'>
            <Field
              name={`${itemName}.unitPrice`}
              type='number'
              component={Input}
              required
              validate={this.checkRequiredField}
              normalize={toFloat}
              min='0.000001'
              step='0.000001'
              pattern='^\d+(?:\.\d{1,6})?$'
              onInvalid={(event) =>
                setErrorMessage(
                  'Por favor, llene este campo siguiendo el formato 0.000000',
                  event
                )
              }
              onInput={(event) => setErrorMessage('', event)}
              onBlur={this.updateAmount.bind(this, position)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Precio Unitario'
            />
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(item.amount || 0, 6)}
          </Table.Cell>
          <Table.Cell textAlign='center' className='weight-field'>
            <Field
              name={`${itemName}.weight`}
              type='number'
              required
              validate={hasToVerfyWeight ? this.checkRequiredField : null}
              normalize={toFloat}
              component={Input}
              min={hasToVerfyWeight ? 0.000001 : 0}
              step='0.000001'
              pattern='^\d+(?:\.\d{1,6})?$'
              onInvalid={(event) =>
                setErrorMessage(
                  'Por favor, llene este campo siguiendo el formato 0.000000',
                  event
                )
              }
              onInput={(event) => setErrorMessage('', event)}
              onBlur={this.updateWeight.bind(this, position)}
              disabled={!editingAllowedOfInvoice}
              placeholder='Peso Neto'
            />
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {getNumericValue(item.totalWeight || 0, 6)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {editingAllowedOfInvoice && (
              <Modal
                size='mini'
                trigger={
                  <span className='link'>
                    <Popup
                      trigger={
                        <span>
                          <Icon link name='close' color='red' size='large' />
                        </span>
                      }
                      content='Eliminar'
                      position='top center'
                      inverted
                    />
                  </span>
                }
                header='¿Desea eliminar el item seleccionado?'
                actions={[
                  {'key': 'cancel', 'content': 'Cancelar'},
                  {
                    'key': 'done',
                    'content': 'Confirmar',
                    'positive': true,
                    'onClick': () => this.onDeleteClick(fields, position),
                    'primary': true,
                  },
                ]}
              />
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {fields, itemsByPage, amount, invoice, totalWeight, invoiceStatus,
      pageNumber, pageSize, allItems} = this.props;
    const editingAllowedOfInvoice = !invoice || (invoice && invoiceStatus === 'I');

    return (
      <>
        {this.renderItems(fields, editingAllowedOfInvoice, {itemsByPage, pageNumber, pageSize})}
        <Table.Row className='totals-row'>
          <Table.Cell textAlign='left' colSpan={6}>
            <span>TOTAL</span>
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <span>{_.sumBy(allItems, 'quantity')}</span>
          </Table.Cell>
          <Table.Cell textAlign='center'></Table.Cell>
          <Table.Cell textAlign='center'>
            <span>
              {'$'}
              {getNumericValue(amount, 6)}
            </span>
          </Table.Cell>
          <Table.Cell textAlign='center'></Table.Cell>
          <Table.Cell textAlign='center'>
            <span>{getNumericValue(totalWeight, 6)}</span>
          </Table.Cell>
          <Table.Cell textAlign='center'></Table.Cell>
        </Table.Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {pageNumber, pageSize, values} = state.form.invoice;
  const systemParameters = state.parameters.list || [];
  const weightVerificationParameter = systemParameters.find((parameter) => parameter.code === 'WEIGHT_CHK') || {};
  return {
    'pageNumber': pageNumber ? pageNumber : 0,
    'pageSize': pageSize ? pageSize : 0,
    'itemsCount': values && values.detail ? values.detail.length : 0,
    'hasToVerfyWeight': weightVerificationParameter.value ? true : false,
  };
};

const {updateTotals, fetchPart} = Actions;

export default connect(mapStateToProps, {
  updateTotals,
  fetchPart,
})(ItemsTable);
